import type { ParagraphFormatValue } from '@aline/common';

const PARAGRAPH_FORMAT_DISPLAY_LABELS: Map<keyof ParagraphFormatValue, string> = new Map([
  ['alignment', 'alignment'],
  ['borders', 'borders'],
  ['indentationFirstLine', 'indent first line'],
  ['indentationLeft', 'indent left'],
  ['indentationRight', 'indent right'],
  ['lineSpacing', 'line spacing'],
  ['listLevel', 'list level'],
  ['shade', 'fill'],
  ['spacingAfter', 'spacing after'],
  ['spacingBefore', 'spacing before'],
]);

/**
 * Human-readable label for a key inside a `paragraphFormat` suggested-edit value,
 * used by the track-changes panel card body.
 */
export function getParagraphFormatDisplayLabel(formatKey: keyof ParagraphFormatValue): string {
  return PARAGRAPH_FORMAT_DISPLAY_LABELS.get(formatKey) ?? 'paragraph format';
}
